module.exports = __webpack_public_path__ + "static/img/195.93c8e6e7.png";